"use client";

import { Icon, Tooltip } from "@kyan/ui";

import { useComboInstrumentsController } from "#/hooks/useComboInstruments.controller";

export const FlipDirectionToggle: React.FC = () => {
  const { comboInstruments, handleFlipDirections } =
    useComboInstrumentsController();

  if (!comboInstruments.length) return null;

  return (
    <Tooltip side="right" content="Flip directions">
      <Icon
        size="sm"
        name="transfer"
        hoverEffect="circle"
        className="text-primary hover:text-textPrimary"
        onClick={handleFlipDirections}
      />
    </Tooltip>
  );
};
